import axios from 'axios'

export function getHeaders (auth, value) {
  if (auth) {
    return {
      Authorization: value
    }
  } else {
    return {
      'Session-id': value
    }
  }
}

export function serializeQueryParams (params) {
  const query = new URLSearchParams()

  function append (key, value) {
    if (value === undefined || value === null) { return }
    if (Array.isArray(value)) {
      value.forEach((item, index) => append(`${key}[${index}]`, item))
    } else if (typeof value === 'object') {
      Object.keys(value).forEach(child => append(`${key}[${child}]`, value[child]))
    } else {
      query.append(key, value)
    }
  }

  Object.keys(params).forEach(key => append(key, params[key]))
  return query.toString()
}

export const waitFor = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const apiClient = axios.create({
  baseURL: process.env.BASE_API,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Application-Key': 'Q5nGL97wRBFlgQ2WOG3XDnHhV33jFIYWdHKArumKS78YaSQA3U'
  }
})

export const apiClientParentingHub = axios.create({
  baseURL: 'https://api.parentinghub.co.id/api/paninti-store',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
    // 'Application-Key': 'Q5nGL97wRBFlgQ2WOG3XDnHhV33jFIYWdHKArumKS78YaSQA3U'
  }
})
